module.exports = __webpack_public_path__ + "media/images/pic/home/pride-pattern-2d6f550798b6c389c97134e429c81055.svg";